<template>
  <layout-main-inner title="标签管理">
    <el-button
      slot="action"
      type="primary"
      @click="additem">
      生产标签
    </el-button>
    <layout-card-wrap :hasSlot="false">
      <!-- <template slot="form">
        <el-input
          v-model="config.productName"
          clearable
          placeholder="请输入商品名称"
          @clear="handleCurrentChange(1)"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </template> -->
      <el-table
        border
        :data="list">
        <el-table-column
          label="开始标签序号"
          prop="beginTagNo">
        </el-table-column>
        <el-table-column
          label="结束标签序号"
          prop="endTagNo">
        </el-table-column>
        <el-table-column
          label="标签数量"
          width="130"
          prop="tagCount">
        </el-table-column>
        <el-table-column
          label="未分配标签数量"
          width="130"
          prop="notAssignTagCount"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          width="240">
          <template slot-scope="{ row }">
            <el-button
              type="primary"
              @click="updateitem(row)">
              分配
            </el-button>
            <el-button
              type="primary"
              @click="viewitem(row)">
              分配记录
            </el-button>
            <el-button
              type="primary"
              @click="downloaditem(row)">
              下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="totalNum"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </layout-card-wrap>
    <edit-modal
      ref="edit"
      :callback="
        () => {
          handleCurrentChange(1)
        }
      "
    />
    <pub-modal
      ref="pub"
      :callback="
        () => {
          handleCurrentChange(1)
        }
      "
    />
    <list-modal ref="list" />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import EditModal from './editModal.vue'
import PubModal from './pubModal.vue'
import ListModal from './listModal.vue'
export default {
  name: 'LabelIndex',
  components: { EditModal, PubModal, ListModal },
  data() {
    return {
      loading: true,
      list: [],
      totalNum: 0,
      config: {
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    downloaditem(row) {
      this.loading = true
      this.$store.dispatch('account/downloadtagsegment', {
        payload: {
          tagSegId: row.tagSegId
        },
        success: () => {
          this.loading = false
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    updateitem(row) {
      this.$refs.pub.init({
        max: row.endTagNo,
        min: row.beginTagNo,
        tagSegId: row.tagSegId,
        maxCount: row.notAssignTagCount
      })
    },
    viewitem(row) {
      this.$refs.list.init({
        tagSegId: row.tagSegId
      })
    },
    additem() {
      this.getnexttagsegmentinfo()
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/gettagsegments', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getnexttagsegmentinfo() {
      this.loading = true
      this.$store.dispatch('account/getnexttagsegmentinfo', {
        payload: {
          tagCount: 1
        },
        success: (res) => {
          this.loading = false
          this.$refs.edit.init({
            beginTagNo: res.data.beginTagNo
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
